'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './FormRow.module.scss';

type GroupProps = BaseComponentProps & {
  children?: ReactNode;
};

function FormRow({
  style,
  className,
  children,
  testId = 'ui-form-row',
}: GroupProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export { FormRow };
